import React from "react";
import {GetCurrentLocale} from "../../components/Utils";
import ContactForm from "./ContactForm";
// Les propriétés du composant
type IDProps = {
}

const ContactFormContainer : React.FC<IDProps> = () => {
  let locale = GetCurrentLocale();
  return(
    <div className="container">
      <ContactForm locale={locale}/>
    </div>
  )
}

export default ContactFormContainer;
